import consumer from './consumer'

consumer.subscriptions.create('ChatChannel', {
    received(data) {
        // Handle Turbo Stream broadcasts for chat list updates
        if (data.type === 'turbo_stream') {
            if (typeof Turbo !== 'undefined') {
                Turbo.renderStreamMessage(data.html)
            }
            return
        }

        // Update the total unread count badge in nav
        if (data.total_unread_count !== undefined) {
            setUnreadCount($('.ChatUnreadCount-All'), data.total_unread_count)
            setNotificationBadgeBridgeUnreadCount(data.total_unread_count)
        }

        // Update individual chat badge (also updated by Turbo Stream in chat list)
        if (data.unread_count !== undefined) {
            setUnreadCount($(`#ChatUnreadCount-${data.chat_id}`), data.unread_count)
        }

        // TODO: This can probably go because it's from the legacy native app
        Paige.refreshSession()

        // Only reload chat for NEW messages, not for count updates (prevents infinite loop)
        if (data.type === 'new_message' && $(`#chat-${data.chat_id}`).is(':visible')) {
            $.get(window.location + '.js').then((x) => {})
        }
    },
})

// Set unread count to a specific value (from server)
function setUnreadCount($el, count) {
    if ($el.length <= 0) {
        return
    }

    $el.text(count)
    $el.attr('data-count', count.toString())
    $el.attr('data-bridge--notification-badge-total-value', count.toString())
    $el.attr('data-bridge--notification-badge-account-value', count.toString())
}

function setNotificationBadgeBridgeUnreadCount(count) {
    const $el = $('#chat-list')
    if ($el.length <= 0) {
        return
    }
    $el.attr('data-bridge--notification-badge-total-value', count.toString())
    $el.attr('data-bridge--notification-badge-account-value', count.toString())
}
